<template>
  <div>
    <!-- eslint-disable vue/no-parsing-error -->
    <Link :underline="false" class="nav-close" @click="sourceSelect=false">
      <svgicon name="cancelwhite" width="12" height="12" :original="true" @click="closeSlider" />
    </Link>
    <div class="drawer-header text-lowercase">
      <span>{{$t('INDENT_SELECT_SOURCE')}}</span>
      <div class="header-action">
        <Button type="text" size="mini" class="button-text-blue" @click="closeSlider">
          {{$t('INDENT_CANCEL')}}
        </Button>
        <Button type="primary" size="mini" @click="save">{{$t('INDENT_ADD')}}</Button>
      </div>
    </div>
    <div class="drawer-body p-0">
      <ElTabs class="tab-default tab-sm tab-bg" v-model="activeTab" @tab-click="callGA('Switch');loadSourceData();">
        <Tab-pane
          v-for="(config,index) in filteredSourceConfig"
          :key="index"
          :label="$t(config.tlabel)"

          v-if="canViewConfig(config.type)"
          :name="config.type.toString()"
          :disabled="getIsDisabled(config.type)"
        >
          <div class="tab-content">
            <div class="w-400" @click="callGA('Search')">
              <Input
                :placeholder="$t('INDENT_SEARCH_NAME_CITY_ID', {label: $t(config.tlabel)})"
                size="mini"
                v-model="searchText"
                class="input-search no-border"
                @input="searchSource"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </Input>
            </div>
            <div class="status-msg" v-if="isLoading && !list.length">
              <span>
                <img :src="Indent" width="170" height="130" alt=""/>
              </span>
            </div>
            <Table
              v-else
              class="table-striped bordered mt-10"
              :data="sourceList"
              :stripe="true"
              :max-height="windowHeight"
              aria-describedby="addSourceListData"
            >
              <table-column width="30">
                <template slot-scope="scope">
                  <Radio
                    :value="selectedPickup.id"
                    :label="scope.row.id"
                    :disabled="isSelectedId(scope.row.id)"
                    @input="selectSource(scope.row)"
                  ></Radio>
                </template>
              </table-column>
              <TableColumn prop="name" :label="$t('INDENT_LABEL_NAME', {label: $t(config.tlabel)})">
                <template slot-scope="scope">
                  <Ellipsis
                    v-if="scope.row.name"
                    :text="scope.row.name"
                    length="30"/>
                </template>
              </TableColumn>
              <TableColumn prop="city" :label="$t('INDENT_LABEL_CITY', {label: $t(config.tlabel)})">
                <template slot-scope="scope">
                  <Ellipsis
                    v-if="scope.row.city"
                    :text="scope.row.city"
                    length="30"/>
                </template>
              </TableColumn>
              <TableColumn :label="$t('INDENT_LABEL_ID', {label: $t(config.tlabel)})">
                <template slot-scope="scope">
                  <Ellipsis
                    v-if="scope.row.reference_id"
                    :text="scope.row.reference_id"
                    length="30"/>
                </template>
              </TableColumn>
              <infinite-loading
                v-if="!getTypeConfig(activeTab).noPaginate && !hasEmpty"
                slot="append"
                @infinite="loadData"
                force-use-infinite-wrapper=".el-table__body-wrapper"
              >
                <div slot="no-more"></div>
                <div slot="no-results"></div>
              </infinite-loading>
            </Table>
          </div>
        </Tab-pane>
      </ElTabs>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
/* eslint-disable no-unused-expressions */
import { sourceAndDestinationType } from 'pando-constants';
import orderConstants from '@common/constants/orderConstants' ;
import { mapGetters } from 'vuex';
import { get } from 'lodash';
import { debounce } from 'debounce';

import Indent from '@common/asset/images/Indent.gif';

export default {
  props: {
    sourceConfig: {
      default: () => [],
      type: Array,
    },
    selectedSourceIds: {
      default: () => [],
      type: Array,
    },
    isEditState: {
      type: Boolean,
      default: false,
    },
    existingSelectedType: {
      type: String,
    },
    currentIndentType: {
      type: String,
    },
  },
  data() {
    return {
      Indent,

      activeTab: null,
      selectedPickup: {},
      sourceAndDestinationType,
      searchText: '',
    };
  },
  created() {
    this.activeTab = this.existingSelectedType ? this.existingSelectedType : this.filteredSourceConfig[0].type.toString();
    this.loadSourceData();
  },
  computed: {
    ...mapGetters({
      currentUser: 'app/currentUser',
      list: 'indentV2/list',
      isLoading: 'indentV2/isLoading',
      filter: 'indentV2/filter',
      hasEmpty: 'indentV2/hasEmpty',
      configurations: 'app/configurations',
    }),
    filteredSourceConfig() {
      const hasCreateReturnInboundPermission = this.$hasPermission('create_return_indent');
      const hasCreateVendorInboundPermission = this.$hasPermission('create_vendor_indent');
      if (this.currentIndentType === orderConstants.INBOUND) {
        if (hasCreateReturnInboundPermission && hasCreateVendorInboundPermission) {
          return this.sourceConfig;
        } else if (hasCreateReturnInboundPermission) {
          return this.sourceConfig.filter(config => config.type === 2);
        } else if (hasCreateVendorInboundPermission) {
          return this.sourceConfig.filter(config => config.type === 3);
        }
        return [];
      }
      return this.sourceConfig;
    },
    getActiveTab() {
      return this.activeTab;
    },
    getIsDisabled() {
      // eslint-disable-next-line consistent-return
      return (type) => {
        if (this.lastMileFeatureEnabled && this.currentIndentType === 'OUTBOUND') {
          const isDepot = String(type) === String(this.sourceAndDestinationType.DEPOT);
          if ((String(type) === String(this.sourceAndDestinationType.CONSIGNEE) && String(this.existingSelectedType) === String(this.sourceAndDestinationType.DEPOT)) || isDepot) {
            return false;
          }
          return true;
        }
        if (this.existingSelectedType && Number(this.existingSelectedType) !== type) {
          return true;
        }
      };
    },
    lastMileFeatureEnabled() {
      return this.$hasFeature('last_mile');
    },
    windowHeight() {
      return `${window.innerHeight - 200}px`;
    },
    sourceList() {
      return (
        this.transformedList &&
        this.transformedList.filter(source => !this.selectedSourceIds.includes(source.id))
      );
    },
    transformedList() {
      const selectedTab = this.activeTab;
      let resultList = [];
      switch (parseInt(selectedTab, 10)) {
        case this.sourceAndDestinationType.VENDOR_DEPOT:
          this.list &&
            this.list.forEach((source) => {
              resultList.push({
                city: source.city,
                name: source.name,
                reference_id: source.reference_id,
                id: source.id, // depot id
                gates: [source.gate],
              });
            });
          break;
        case this.sourceAndDestinationType.DEPOT:
          this.list &&
            this.list.forEach((source) => {
              resultList.push({
                city: source.city,
                name: source.name,
                reference_id: source.reference_id,
                id: source.id,
                gates: source.gates.filter(gate => !gate.is_virtual_gate),
              });
            });
          break;
        default:
          resultList = [...this.list];
          break;
      }
      return resultList;
    },
  },
  methods: {
    closeSlider() {
      this.$emit('closeSourceSlider');
    },
    selectSource(value) {
      this.selectedPickup = value;
    },
    save() {
      this.closeSlider();
      if (this.selectedPickup.reference_id) {
        this.$emit('addNewSource', {
          ...this.selectedPickup,
          ...{ type: this.activeTab },
        });
      }
    },

    // call the source data w.r.t the selected tab
    loadSourceData() {
      this.searchText = null;
      this.$store.commit('indentV2/resetListing');
      this.loadData();
    },

    callGA(type) {
      const selectedTab = parseInt(this.activeTab, 10);
      const config = this.sourceConfig.find(val => val.type === selectedTab);
      if (config.GAEventConstants) {
        const gaEvents = [...config.GAEventConstants];
        gaEvents[1] = `${type} ${gaEvents[1]}`;
        this.$emit('setGA', ...gaEvents);
      }
    },

    // search for source
    searchSource: debounce(async function search() {
      this.$store.commit('indentV2/resetListing');
      this.loadData();
    }, 300),

    async loadData($state = null) {
      const selectedTab = parseInt(this.activeTab, 10);
      const config = this.sourceConfig.find(val => val.type === selectedTab);
      let params = { ...this.filter };
      switch (parseInt(selectedTab, 10)) {
        case this.sourceAndDestinationType.CONSIGNEE:
          params = {
            id: this.currentUser.id,
            filters: {
              ...params,
            },
          };
          break;
        case this.sourceAndDestinationType.VENDOR_DEPOT:
          params = {
            filters: {
              ...params,
              type: 2, // TODO: @PRIYA change as constant
            },
          };
          break;
        default:
      }
      if (this.searchText) {
        if (!params.filters) {
          params.filters = {};
        }
        params.filters.query = this.searchText;
      }
      await this.$store.dispatch(config.storeCallPath, params);

      if ($state) {
        if (!this.hasEmpty) {
          $state.loaded();
        }
      }
    },

    getTypeConfig(type) {
      return this.sourceConfig.find(val => val.type === parseInt(type, 10));
    },

    canViewConfig(type) {
      const configByType = this.getTypeConfig(type);
      return configByType.permission ? get(this.configurations, configByType.permission) : true;
    },

    isSelectedId(id) {
      return this.selectedSourceIds && this.selectedSourceIds.length ?
        Boolean(this.selectedSourceIds.some(val => val === id)) : false;
    },
  },
};
</script>
